import { Flex, Input, Label, ValidationMessage } from '@modusign/design-system';

import DataLabelTooltip from '@app/components/DataLabelTooltip';

interface DataLabelInputProps {
  value: string;
  errorMessage: string;
  onChange: (_value: string) => void;
}

const defaultProps = {
  initialValue: '',
};

function DataLabelInput({ value, errorMessage, onChange }: DataLabelInputProps) {
  return (
    <>
      <Label fontSize="sm" mb={0}>
        <Flex alignItems="center" mb={2}>
          데이터 라벨
          <DataLabelTooltip />
        </Flex>
        <Input
          fontSize="sm"
          isInvalid={!!errorMessage}
          maxLength={200}
          name="dataLabel"
          placeholder="200자 이내로 입력"
          value={value}
          width="100%"
          onChange={(event) => onChange(event.target.value)}
          onFocus={(event) => event.target.select()}
        />
      </Label>

      {errorMessage && <ValidationMessage>{errorMessage}</ValidationMessage>}
    </>
  );
}

DataLabelInput.defaultProps = defaultProps;

export default DataLabelInput;
